var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding4LineAlt = function SvgBuilding4LineAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#building-4-line-alt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16h1.5v1.5H1.75V16h1.5V3.25A.75.75 0 0 1 4 2.5h12a.75.75 0 0 1 .75.75zm-1.5 0V4H4.75v12zM7 9.25h2.25v1.5H7zm0-3h2.25v1.5H7zm0 6h2.25v1.5H7zm3.75-3H13v1.5h-2.25zm0-3H13v1.5h-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M20 11.5V14h-7.5v-2.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "building-4-line-alt_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgBuilding4LineAlt;